import { Popup } from 'devextreme-react/popup';
import { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import Order from '../Components/Orders';
import Patient from '../Components/Patient';
import { clearPatient, setData, setLoading, setMode } from '../../../../contexts/slices/quotations';
import { useApiConfiguration } from '../../../../api/api.configuration';
import { Button, DataGrid, Form, Tooltip } from 'devextreme-react';
import { Column, Editing, Item, Toolbar } from 'devextreme-react/data-grid';
import { QuotationStudiesSearchSelect, QuotationStudyItem } from './components/QuotationStudiesSearchSelect';
import { FacturacionTarifas } from '../../../../types/types.facturacion';
import { newToast } from '../../../../components';
import { formatNumber } from 'devextreme/localization';
import '../Quotations.scss';
import { Disccount, ordMuestras, resButtonsPrint } from '../../../../images/icons';
import { useScreenSize } from '../../../../utils/media-query';
import { ButtonItem, Label, SimpleItem } from 'devextreme-react/form';
import { useApiQuotation } from '../../../../api/api.Quotations';
import { ModalReportQuotation } from '../../../../components/library/reporting/ModalReportQuotations';
import { useApiPatient } from '../../../../api/api.patient';
import { CustomFilters, TypeTableFilter } from '../../../../types/types.system';
import { useApiOrders } from '../../../../api/api.orders';
import { SampleTubesPanel, TmBcListDTO } from '../../../../components/library/info-order/OrderModules/components/SampleTubesPanel';

type PopupProps = {
  visible: boolean;
  wrapperAttr?: { class: string };
  setVisible: (update: boolean) => void;
  currentData?: any[];
  idQuotation?: number;
};

type discounttp = {
  type: 'value' | 'percentage' | null;
  value: number;
};

const discount: discounttp = { type: null, value: 0 };

const Index = ({ visible, setVisible, wrapperAttr = { class: '' }, currentData, idQuotation }: PopupProps) => {
  const ColumnsContainerOrderOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerOrderOrders')[0], shallowEqual)?.Cgn_Resultado;
  const ColumnsContainerPatientOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerPatientOrders')[0], shallowEqual)?.Cgn_Resultado;
  const mode = useAppSelector((x) => x.globalQuotation.Mode);
  const modePatient = useAppSelector((x) => x.globalOrders.CurrentOrder.ModePatient);
  const dataGridRef = useRef<DataGrid>(null);
  const [lstTarifas, setLstTarifas] = useState([]);
  const [itemsAdded, setItemsAdded] = useState<FacturacionTarifas[]>([]);
  const QuotationData = useAppSelector((x) => x.globalQuotation.Quotation);
  const PatientData = useAppSelector((x) => x.globalQuotation.PatientData);
  const { GetTarifasByIdContratoWithStudies } = useApiConfiguration();
  const frmRef = useRef<Form>(null);
  const [modalDiscountVisible, setModalDiscountVisible] = useState(false);
  const { NewQuotation, EditQuotation, GetById } = useApiQuotation();
  const { GetSampleTypeAndBarcode } = useApiOrders();
  const [visibleReport, setVisibleReport] = useState(false);
  const dispatch = useAppDispatch();
  const [loadingPac, setLoadingPac] = useState(false);
  const { findUser } = useApiPatient();
  const { isSmall, isXSmall } = useScreenSize();
  const [sampleTubesData, setSampleTubesData] = useState<TmBcListDTO[]>([]);
  const [samplePanelVisible, setSamplePanelVisible] = useState<boolean>(true);
  const [muestrasPopupVisible, setMuestrasPopupVisible] = useState<boolean>(false);
  // Dentro de tu componente
  const [totals, setTotals] = useState({
    subtotal: 0,
    discount: 0,
    total: 0,
  });

  const onCancelClick = () => {
    dispatch(clearPatient());
    dispatch(setMode({ mode: 'view' }));
    setVisible(false);
  };

  // Handler para el nuevo componente de búsqueda de estudios
  const handleStudySelected = useCallback(
    (study: QuotationStudyItem) => {
      if (!study.originalData) {
        newToast('ERROR', 'Datos del estudio no disponibles', 3);
        return;
      }
      
      if (itemsAdded.filter((x) => x.Tf_Es_Id === study.originalData!.Tf_Es_Id).length > 0) {
        newToast('WARNING', `Ya se ha agregado el estudio '${study.originalData!.Estudio.Es_Nombre}'`, 5);
        return;
      }
      
      setItemsAdded((prevItems) => [...prevItems, study.originalData!]);
    },
    [itemsAdded, setItemsAdded]
  );

  // Convertir estudios agregados a formato del nuevo componente para evitar duplicados
  const addedStudiesAsItems = useMemo((): QuotationStudyItem[] => {
    return itemsAdded.map(study => ({
      id: study.Tf_Es_Id,
      code: study.Estudio?.Es_Codigo || `E${study.Tf_Es_Id}`,
      name: study.Estudio?.Es_Nombre || 'Estudio sin nombre',
      group: study.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || 'Sin área',
      price: study.Tf_Valor,
      isActive: study.Tf_Estado,
      Tf_Es_Id: study.Tf_Es_Id,
      Tf_Es_Codigo: study.Estudio?.Es_Codigo || '',
      Tf_Es_Nombre: study.Estudio?.Es_Nombre || '',
      Tf_Aa_Nombre: study.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || '',
      Tf_ValorTarifa: study.Tf_Valor,
      originalData: study
    }));
  }, [itemsAdded]);

  const calculateSubtotal = () => {
    // Calcular el subtotal sumando todos los valores de la columna Tf_Valor
    return itemsAdded.reduce((acc, item) => acc + item.Tf_Valor, 0);
  };

  const calculateDiscount = (subtotal: number) => {
    // Calcular el descuento sobre el subtotal
    //return subtotal * (discount / 100);
    if (discount.type && discount.value > 0) {
      if (discount.type === 'percentage') {
        return subtotal * (discount.value / 100);
      }
      return discount.value;
    }
    return 0;
  };

  const calculateTotal = (subtotal: number, discount: number) => {
    // Calcular el total: subtotal - descuento
    return subtotal - discount;
  };

  // Cuando el contrato cambia
  useEffect(() => {
    if (QuotationData.Cz_Cn_Id && QuotationData.Cz_Cn_Id > 0 && mode !== 'view') {
      GetTarifasByIdContratoWithStudies(QuotationData.Cz_Cn_Id).then((res) => {
        setLstTarifas(res);
        if (mode === 'new' || mode === 'update') {
          // Ahora no quiero limpiar los items sino que si hay un contrato nuevo deseo comparar los estudios agregados y cambiarles la tarifa y sino existe en el nuevo contrato, ponerlo con tarifa 0
          setItemsAdded(
            itemsAdded.map((item) => {
              const newTarifa = res.find((t) => t.Tf_Es_Id === item.Tf_Es_Id);
              return {
                ...item,
                Tf_Valor: newTarifa ? newTarifa.Tf_Valor : 0,
              };
            })
          );
        }
      });
    }
  }, [QuotationData.Cz_Cn_Id]);

  // Cuando vamos a editar para que deje llenar los estudios
  useEffect(() => {
    if (QuotationData.Cz_Cn_Id && QuotationData.Cz_Cn_Id > 0 && mode !== 'update') {
      GetTarifasByIdContratoWithStudies(QuotationData.Cz_Cn_Id).then((res) => {
        setLstTarifas(res);
      });
    }
  }, [mode]);

  useEffect(() => {
    if (mode !== 'new' && QuotationData && QuotationData.Cz_Pc_Id && modePatient === 'view' && visible) {
      const filters: CustomFilters[] = [{ Field: 'Pc_Id', Value: QuotationData.Cz_Pc_Id, TypeFilter: TypeTableFilter.Equal }];
      findUser(filters, setLoadingPac, true, 'quotations');
    }
  }, [QuotationData, visible]);

  // Limpiar los items cuando se cierra el modal o se crea un nuevo item
  useEffect(() => {
    if ((visible && mode === 'new') || !visible) {
      setItemsAdded([]);
      setLstTarifas([]);
      frmRef.current?.instance?.resetValues();
      return;
    }
  }, [visible]);

  // Actualizar totales cuando cambian los items agregados
  useEffect(() => {
    updateTotals();
  }, [itemsAdded]);

  // Cargar tubos/muestras cada vez que cambian los estudios
  const studyIdsKey = useMemo(() => {
    return itemsAdded.map((s) => s.Tf_Es_Id).sort((a, b) => a - b).join(',');
  }, [itemsAdded]);

  useEffect(() => {
    if (!studyIdsKey) {
      setSampleTubesData([]);
      return;
    }
    const studyIds = studyIdsKey.split(',').map(Number);
    GetSampleTypeAndBarcode(studyIds).then((res: TmBcListDTO[]) => {
      setSampleTubesData(res || []);
    });
  }, [studyIdsKey]);

  useEffect(() => {
    if (idQuotation && idQuotation > 0 && visible) {
      dispatch(setMode({ mode: 'view', idQuotation: -1 }));
      GetById(idQuotation).then((res) => {
        if (res) {
          const data = res.Detalle.map((x) => {
            return { ...x, Tf_Valor: x.Czd_ValUnitario, Tf_Es_Id: x.Czd_Es_Id };
          });
          setItemsAdded(data);
          //Eliminamos el detalle de res
          res.Detalle = undefined;
          dispatch(setData(res));
          if (res.Cz_TipoDescuento && res.Cz_TipoDescuentoValor) {
            frmRef.current?.instance?.updateData('type', res.Cz_TipoDescuento === 1 ? 'percentage' : 'value');
            frmRef.current?.instance?.updateData('value', res.Cz_TipoDescuentoValor);
          }
        }
      });
    }
  }, [idQuotation, visible]);

  // cargar datos
  useEffect(() => {
    if (visible && mode === 'view' && currentData) {
      //Asignar los datos pero cambiar la propiedad Czd_ValUnitario por Tf_Valor
      const data = currentData.map((x) => {
        return { ...x, Tf_Valor: x.Czd_ValUnitario, Tf_Es_Id: x.Czd_Es_Id };
      });

      setItemsAdded(data);
      if (QuotationData.Cz_TipoDescuento && QuotationData.Cz_TipoDescuentoValor) {
        frmRef.current?.instance?.updateData('type', QuotationData.Cz_TipoDescuento === 1 ? 'percentage' : 'value');
        frmRef.current?.instance?.updateData('value', QuotationData.Cz_TipoDescuentoValor);
      }
    }
  }, [QuotationData]);

  const updateTotals = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount(subtotal);
    const total = calculateTotal(subtotal, discountAmount);

    // Actualizar el estado con los nuevos valores
    setTotals({
      subtotal: subtotal,
      discount: discountAmount,
      total: total,
    });
  };

  const handleAddDiscount = useCallback(() => {
    if (mode === 'view') {
      return;
    }
    setModalDiscountVisible(true);
  }, [setModalDiscountVisible, mode]);

  const onCancelModalDiscountClick = useCallback(() => {
    setModalDiscountVisible(false);
  }, [setModalDiscountVisible]);

  const hanAddDiscountConfirm = useCallback(
    (e: { preventDefault: () => void }) => {
      updateTotals();
      setModalDiscountVisible(false);
      e.preventDefault();
    },
    [setModalDiscountVisible, updateTotals]
  );

  // Quitar el descuento aplicado: deja tipo/valor en nulo y recalcula totales.
  const handleRemoveDiscount = useCallback(() => {
    discount.type = null;
    discount.value = 0;
    frmRef.current?.instance?.resetValues();
    updateTotals();
    setModalDiscountVisible(false);
  }, [updateTotals]);

  const handleClicSave = useCallback(() => {
    if (mode !== 'view' && itemsAdded.length === 0) {
      newToast('WARNING', 'Debe agregar al menos un estudio', 5);
      return;
    }

    dispatch(setLoading(true));
    const items = itemsAdded.map((x) => {
      return { Czd_Es_Id: x.Tf_Es_Id, Czd_ValUnitario: x.Tf_Valor };
    });

    const QuotData = {
      Cz_Cn_Id: QuotationData.Cz_Cn_Id,
      Cz_Pc_Id: PatientData.Pc_Id,
      Cz_Se_Id: QuotationData.Cz_Se_Id,
      Cz_Subtotal: totals.subtotal,
      Cz_Descuento: totals.discount,
      Cz_TipoDescuento: discount.type && discount.value ? (discount.type === 'percentage' ? 1 : 2) : null,
      Cz_TipoDescuentoValor: discount.type ? discount.value : null,
      Cz_ValorTotal: totals.total,
      Cz_CamposDinamicos: JSON.stringify(QuotationData.AditionalFields),
      Cz_Nota: '', //Falta crearle el campo en el front
      Detalle: items,
    };
    switch (mode) {
      case 'new':
        NewQuotation(QuotData).finally(() => {
          dispatch(setLoading(false));
          setVisible(true);
        });
        break;
      case 'update':
        // Actualizar cotización
        EditQuotation(QuotData, QuotationData.Cz_Id).finally(() => {
          dispatch(setLoading(false));
          setVisible(true);
        });
        break;
      default:
        break;
    }
  }, [itemsAdded, QuotationData, PatientData, totals, mode]);

  const handleCloseModalPrint = useCallback(() => {
    setVisibleReport(false);
  }, [setVisibleReport]);

  const handleClicPrint = useCallback(() => {
    setVisibleReport(true);
  }, [setVisibleReport]);

  return (
    <div>
      <Popup title={mode === 'new' ? 'Nueva cotización' : mode === 'update' ? 'Actualizar cotización' : 'Ver cotización'} visible={visible} showCloseButton={true} onHiding={onCancelClick} width={'98%'} wrapperAttr={{ ...wrapperAttr, class: `${wrapperAttr?.class} form-popup` }} height='98%'>
        <div className='view-wrapper view-wrapper-contact-details'>
          <div className='container-forms-ord'>
            <div className={`colOrd-${ColumnsContainerOrderOrders ? ColumnsContainerOrderOrders : 6}`}>
              <Order onClickSave={handleClicSave} onClickCancel={onCancelClick} />
            </div>
            <div className={`colOrd-${ColumnsContainerPatientOrders ? ColumnsContainerPatientOrders : 6}`}>
              <Patient />
            </div>
          </div>
          <div className='detail-values-container' style={{ display: 'flex', height: 'calc(100% - 50px)', overflow: 'hidden' }}>
            <div style={{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0, marginRight: samplePanelVisible && !(isSmall || isXSmall) ? '4px' : 0 }}>
              <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
              <DataGrid className='grid' onRowUpdated={updateTotals} onRowRemoved={updateTotals} dataSource={itemsAdded} ref={dataGridRef} hoverStateEnabled={true} height='100%' width='100%' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
                <Editing allowUpdating mode='cell' allowDeleting={mode === 'new' || mode === 'update'} />
                <Toolbar>
                  <Item location='before'>
                    <QuotationStudiesSearchSelect
                      dataSource={lstTarifas}
                      onStudySelected={handleStudySelected}
                      selectedStudies={addedStudiesAsItems}
                      placeholder="Buscar estudios..."
                      label="Estudios"
                      disabled={mode === 'loading' || mode === 'view' || lstTarifas.length === 0}
                      className="comboboxItems"
                      minSearchLength={1}
                    />
                  </Item>
                  <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <Button id='ImprimirResult' onClick={handleClicPrint} icon={resButtonsPrint} text='Imprimir resultados' stylingMode='text' disabled={mode !== 'view' || (mode === 'view' && !QuotationData?.Cz_Id)} />
                    <Tooltip target={'#ImprimirResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Imprimir cotización
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='auto'>
                    <div className='separator' />
                  </Item>
                  <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <div className='messages'>
                      <Button id='ApplyDisccount' icon={Disccount} text='Aplicar descuento' stylingMode='text' onClick={handleAddDiscount} />
                      {discount.type && discount.value && <div className='dx-badge'>{discount.type === 'percentage' ? `%` : `$`}</div>}
                      <Tooltip target={'#ApplyDisccount'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        {discount.type && discount.value ? (discount.type === 'percentage' ? `${discount.value}% aplicado` : `${formatNumber(discount.value, { type: 'currency' })} aplicado`) : 'Aplicar un descuento'}
                      </Tooltip>
                    </div>
                  </Item>
                  {(isSmall || isXSmall) && (
                    <Item location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                      <Button id='btnMuestrasQuot' icon={ordMuestras} text='Muestras' stylingMode='text' onClick={() => setMuestrasPopupVisible(true)} />
                      <Tooltip target={'#btnMuestrasQuot'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        Ver muestras
                      </Tooltip>
                    </Item>
                  )}
                  {!(isSmall || isXSmall) && (
                    <Item location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                      <Button id='btnToggleMuestrasQuot' icon={ordMuestras} text={samplePanelVisible ? 'Ocultar muestras' : 'Muestras'} stylingMode='text' onClick={() => setSamplePanelVisible(!samplePanelVisible)} />
                      <Tooltip target={'#btnToggleMuestrasQuot'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        {samplePanelVisible ? 'Ocultar panel de muestras' : 'Ver panel de muestras'}
                      </Tooltip>
                    </Item>
                  )}
                </Toolbar>
                <Column dataField='Estudio.Es_Codigo' allowEditing={false} caption='CÓDIGO' width={80} alignment='center' />
                <Column dataField='Estudio.Es_Nombre' allowEditing={false} caption='ESTUDIO' minWidth={250} />
                <Column dataField='Tf_Valor' caption='TARIFA' dataType='number' format='currency' width={120} minWidth={100} alignment='center' />
              </DataGrid>
              </div>
              <div className='totals-summary'>
                <div>
                  <strong>Subtotal: </strong>
                  <span>{formatNumber(totals.subtotal, { type: 'currency' })}</span>
                </div>
                <div>
                  <strong>Descuento: </strong>
                  <span>{formatNumber(totals.discount, { type: 'currency' })}</span>
                </div>
                <div>
                  <strong>Total: </strong>
                  <span>{formatNumber(totals.total, { type: 'currency' })}</span>
                </div>
              </div>
            </div>
            {!(isSmall || isXSmall) && samplePanelVisible && (
              <div style={{ flex: '0 0 250px', minWidth: 0, minHeight: 0, alignSelf: 'stretch', overflow: 'auto' }}>
                <SampleTubesPanel data={sampleTubesData} />
              </div>
            )}
          </div>
        </div>
      </Popup>

      <Popup title='Agregar descuento' fullScreen={isSmall || isXSmall} width={400} height={'auto'} visible={modalDiscountVisible} onHiding={onCancelModalDiscountClick} onHidden={onCancelModalDiscountClick} showCloseButton={true}>
        <form action='#' onSubmit={hanAddDiscountConfirm}>
          <Form formData={discount} ref={frmRef}>
            <SimpleItem
              isRequired
              dataField='type'
              editorType='dxSelectBox'
              editorOptions={{
                showClearButton: true,
                items: [
                  { label: 'Porcentaje', value: 'percentage' },
                  { label: 'Valor fijo', value: 'value' },
                ],
                displayExpr: 'label',
                valueExpr: 'value',
              }}>
              <Label text='Tipo de descuento' />
            </SimpleItem>
            <SimpleItem isRequired dataField='value' editorType='dxNumberBox'>
              <Label text='Valor' />
            </SimpleItem>
            <ButtonItem visible={!!discount.type} buttonOptions={{ type: 'danger', text: 'Quitar descuento', useSubmitBehavior: false, onClick: handleRemoveDiscount }} />
            <ButtonItem buttonOptions={{ type: 'default', text: 'Aplicar', useSubmitBehavior: true }} />
          </Form>
        </form>
      </Popup>

      <ModalReportQuotation visible={visibleReport} setVisible={handleCloseModalPrint} reportName='Cotizaciones' idQuotation={QuotationData ? QuotationData.Cz_Id : -1} />

      {/* Popup de muestras para dispositivos pequeños */}
      {(isSmall || isXSmall) && (
        <Popup
          visible={muestrasPopupVisible}
          onHiding={() => setMuestrasPopupVisible(false)}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title='Muestras'
          width={isXSmall ? '100%' : 400}
          height='auto'
          fullScreen={isXSmall}
        >
          <SampleTubesPanel data={sampleTubesData} />
        </Popup>
      )}
    </div>
  );
};

export default Index;
